import { chamferClipPath } from "@/lib/exploreImages";
import { cn } from "@/lib/utils";

export const ExploreImageStageButton = ({
  children,
  className,
  onClick,
  title,
}: {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
  title: string;
}) => (
  <button
    aria-label={title}
    className={cn(
      "flex h-10 w-10 shrink-0 items-center justify-center bg-black/[0.06] text-[#212327]/80 backdrop-blur transition-colors hover:bg-black/[0.12] hover:text-[#212327] dark:bg-white/[0.06] dark:text-white/80 dark:hover:bg-white/[0.14] dark:hover:text-white",
      className,
    )}
    onClick={onClick}
    style={{ clipPath: chamferClipPath(8) }}
    title={title}
    type="button"
  >
    {children}
  </button>
);
